import { ChessMove } from './AlphaBeta';
import { EngineRequest } from './AlphaBeta.worker';
import { CastlingRights, EnPassantTarget } from './ChessLogic';
import { PieceType } from './Constants';

export function getBestMoveInWorker(
  board: PieceType[][],
  castlingRights: CastlingRights,
  enPassantTarget: EnPassantTarget | null
): Promise<ChessMove> {
  const worker = new Worker(new URL('./AlphaBeta.worker.ts', import.meta.url));
  const request: EngineRequest = { board, castlingRights, enPassantTarget };

  return new Promise((resolve, reject) => {
    worker.onmessage = (event: MessageEvent<ChessMove>) => {
      worker.terminate();
      resolve(event.data);
    };
    worker.onerror = event => {
      worker.terminate();
      reject(new Error(event.message || 'Chess engine worker failed'));
    };
    worker.postMessage(request);
  });
}